export default __webpack_public_path__ + "static/media/bfa.cd439482.svg";